module.exports = __webpack_public_path__ + "media/audio7.b9551228.mp3";